import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { ToasterService } from 'angular2-toaster';
import { EMPLOYEE_NO_ERROR_MSG, isEmployeeNoComplete, isEmployeeNoTypingAllowed, isEmployeeNoValidationEnabled } from '../utils/employee-no.util';

@Directive({
  selector: '[appEmployeeNo]'
})
export class EmployeeNoDirective {

  @Input('appEmployeeNo') enableEmployeeNoValidation: any;

  constructor(private el: ElementRef, private toasterService: ToasterService) { }

  @HostListener('keydown', ['$event'])
  onKeyDown(e: KeyboardEvent) {
    if (!isEmployeeNoValidationEnabled(this.enableEmployeeNoValidation)) {
      return;
    }
    if (e.ctrlKey || e.metaKey || ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete', 'Home', 'End'].indexOf(e.key) !== -1) {
      return;
    }
    const input = this.el.nativeElement;
    const v = input.value || '';
    const next = v.substring(0, input.selectionStart) + e.key + v.substring(input.selectionEnd);
    if (!isEmployeeNoTypingAllowed(next)) {
      e.preventDefault();
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(e: ClipboardEvent) {
    if (!isEmployeeNoValidationEnabled(this.enableEmployeeNoValidation)) {
      return;
    }
    e.preventDefault();
    const clipboardData = e.clipboardData || (window as any).clipboardData;
    const pasted = clipboardData ? clipboardData.getData('text') : '';
    const input = this.el.nativeElement;
    const v = input.value || '';
    const start = input.selectionStart != null ? input.selectionStart : v.length;
    const end = input.selectionEnd != null ? input.selectionEnd : start;
    const next = v.substring(0, start) + pasted + v.substring(end);
    input.value = next;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    if (!isEmployeeNoComplete(next)) {
      this.toasterService.pop('info', 'Info', EMPLOYEE_NO_ERROR_MSG);
    }
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src1860559092/src/src/app/shared/directive/employee-no.directive.ts